import React from 'react';
import { Helmet } from 'react-helmet';

// Workspaces
// @ts-ignore
import { ErrorBoundary } from 'workspaces/redux-error-boundary';

import { ADMIN, PAYROLL } from 'components/RoleGate/constants';

// Global Components
// @ts-ignore
import ErrorBoundaryAlert from 'components/ErrorBoundaryAlert';
import PageTitleAndFilters from 'components/PageTitleAndFilters';
import SaveMessage from 'components/SaveMessage';
import PageTitleAndFiltersPusher from 'components/PageTitleAndFiltersPusher';
// @ts-ignore
import CurrentSeasonInProgressGate from 'components/CurrentSeasonInProgressGate';
// @ts-ignore
import DatePagination from 'components/DatePagination';
// @ts-ignore
import PageWrapper from 'components/PageWrapper';
import RoleGate from 'components/RoleGate';

// Components
import TimesheetSubmissionsTable from './components/TimesheetSubmissionsTable';
import TimesheetSubmissionsRevertModal from './components/TimesheetSubmissionsRevertModal';

// Environment
const { REACT_APP_PROJECT_NAME } = process.env;

const TimesheetSubmissions = (): React.ReactElement => (
    <RoleGate requiredRoles={[ADMIN, PAYROLL]}>
        <ErrorBoundary
            namespace="TimesheetHolidays"
            FallbackComponent={<ErrorBoundaryAlert />}
        >
            <Helmet>
                <title>Submissions - {REACT_APP_PROJECT_NAME}</title>
            </Helmet>
            <PageTitleAndFilters
                title="Submissions"
                hideFilters
                CustomSearch={<DatePagination />}
                MessageComponent={
                    <SaveMessage namespace={['PAYROLL_EXPORT_DELETE']} />
                }
            />
            <PageTitleAndFiltersPusher>
                <PageWrapper top={0} bottom={50}>
                    <TimesheetSubmissionsTable />
                </PageWrapper>
                <CurrentSeasonInProgressGate>
                    <TimesheetSubmissionsRevertModal />
                </CurrentSeasonInProgressGate>
            </PageTitleAndFiltersPusher>
        </ErrorBoundary>
    </RoleGate>
);

export default TimesheetSubmissions;
